import {useSyncExternalStore} from 'react';
import {isServer} from 'coreUtils/utils';
import {usePathContext} from './PathnameContext';

const subscribe = (callback: () => void) => {
	if (isServer) {
		return () => null;
	}

	const handler = () => callback();
	window.addEventListener('popstate', handler);
	window.addEventListener('pushstate', handler);
	window.addEventListener('replacestate', handler);

	return () => {
		window.removeEventListener('popstate', handler);
		window.removeEventListener('pushstate', handler);
		window.removeEventListener('replacestate', handler);
	};
};

const getSnapshot = () => !isServer ? window.location.pathname : '';

const usePathname = (): string => {
	const pathContext = usePathContext();
	const syncExternalStore = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

	if (isServer) {
		return pathContext.pathname;
	} else {
		return syncExternalStore;
	}
};

export default usePathname;